module.exports = __webpack_public_path__ + "assets/keypad-sounds/beepbase-95977b3fc295f9b2bc3dee6a5cc150e7.wav";